export default __webpack_public_path__ + "static/Business-Process-Optimization-1e3a0a0727cdf6aa6ee6ebfc39f8ef3b.webp";